import { axiosInstance } from '../../utils';
import { IAudioCreation } from '../../@types';

interface Payload {
  id: string;
  name: string;
}

export const editCreatedAudio = async (payload: Payload): Promise<IAudioCreation> => {
  const res = await axiosInstance.put(`/api/audios/audio-build`, payload);
  return res.data;
};
